export default __webpack_public_path__ + "media/components/PackageEditor/images/preview-slot_picker-9ae3ab4084f15e81c9578c7dfb300c82.png";